var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25391 26C19.6487 26 25.5799 26 26.7462 26",
    stroke: "#302F3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.25293,
    y: 14.2544,
    width: 3.49874,
    height: 10.7461,
    rx: 1.74937,
    fill: "url(#paint0_linear_79_634)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.25293,
    y: 14.2544,
    width: 3.49874,
    height: 10.7461,
    rx: 1.74937,
    stroke: "#302F3A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0029,
    y: 11.2554,
    width: 3.49874,
    height: 13.745,
    rx: 1.74937,
    fill: "url(#paint1_linear_79_634)",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0029,
    y: 11.2554,
    width: 3.49874,
    height: 13.745,
    rx: 1.74937,
    stroke: "url(#paint2_linear_79_634)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.75,
    y: 14.2539,
    width: 3.49874,
    height: 10.7461,
    rx: 1.74937,
    fill: "url(#paint3_linear_79_634)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.75,
    y: 14.2539,
    width: 3.49874,
    height: 10.7461,
    rx: 1.74937,
    stroke: "#302F3A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 16.2534,
    width: 3.49874,
    height: 8.74685,
    rx: 1.74937,
    fill: "url(#paint4_linear_79_634)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 16.2534,
    width: 3.49874,
    height: 8.74685,
    rx: 1.74937,
    stroke: "#302F3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67285 10.8615L12.6875 6.84685C13.0781 6.45632 13.7112 6.45632 14.1017 6.84685L17.7255 10.4706C18.1197 10.8648 18.7601 10.8605 19.149 10.4611L24.4664 5M24.4664 5H22.6754M24.4664 5V6.6282",
    stroke: "url(#paint5_linear_79_634)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_634",
    x1: 7.25293,
    y1: 14.2544,
    x2: 12.649,
    y2: 15.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_79_634",
    x1: 13.7523,
    y1: 11.9426,
    x2: 13.7523,
    y2: 25.0004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_79_634",
    x1: 13.7523,
    y1: 11.2554,
    x2: 13.7523,
    y2: 25.0004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_79_634",
    x1: 16.75,
    y1: 14.2539,
    x2: 22.146,
    y2: 15.3105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_79_634",
    x1: 21.5,
    y1: 16.2534,
    x2: 26.7964,
    y2: 17.5276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_79_634",
    x1: 24.4967,
    y1: 5.38243,
    x2: 7.75277,
    y2: 10.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.5e05c928340face99e37b21a18efe48b.svg";
export { ForwardRef as ReactComponent };